interface AnalyticsPage {
    id?: string;
    excludeFromAnalytics?: boolean;
}

export interface AnalyticsPagesOptions {
    /** Ids of excluded pages to keep anyway, e.g. a saved selection that was excluded afterwards. */
    keepIds?: string[];
}

/**
 * Drops pages that were excluded from analytics. Filters on the field only; the
 * `excludePagesFromAnalytics` segment flag gates the toggle, not this filter.
 */
export function filterAnalyticsPages<T extends AnalyticsPage> (pages: T[], { keepIds = [] }: AnalyticsPagesOptions = {}): T[] {
    return pages.filter((page) => !page.excludeFromAnalytics || keepIds.includes(page.id as string));
}
